import type { TimelineStageKey } from '@/api/cockpit';

export function mapActivityStageToTimelineStage(stage: string): TimelineStageKey | null {
  switch (stage) {
    case 'ingestion':
      return 'ingestion';
    case 'ocr':
      return 'ocr';
    case 'classification':
      return 'classification';
    case 'duplicate_check':
      return 'duplicate';
    case 'legal_entity_matching':
    case 'site_matching':
    case 'customer_matching':
    case 'matching_fanout':
    case 'product_matching':
    case 'uom_mapping':
    case 'payment_terms_mapping':
    case 'delivery_terms_mapping':
    case 'delivery_mode_mapping':
      return 'matching';
    case 'validation':
      return 'validation';
    case 'draft_creation':
      return 'draft';
    case 'confirming':
      return 'confirm';
    case 'acknowledgement':
      return 'acknowledgement';
    default:
      return null;
  }
}
